import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Checks if a string is a valid link using the provided regex.
 * @param {string} url - The URL string to validate.
 * @returns {boolean} True if valid, false otherwise.
 */
export function isValidLink(url: string): boolean {
  // Final improved regex: no unnecessary escapes, does not match empty string
  const regex = /^(https?:\/\/)?([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})([\/\w .-]+)?\/?$/;
  return url.length > 0 && regex.test(url);
}

export const formatSecondsToTimer = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};
